module.exports = __webpack_public_path__ + "img/access.1b105d90.svg";